import type { CasinoGame } from '@ps/web-casino-types';

import type { Entity, CasinoGame as GameEntity } from '../entities/index';
import { casinoGame } from '../entities/index';

export const gameEntity = (game: CasinoGame, index?: number): Entity<GameEntity> =>
  casinoGame({
    gameTags: game.tags,
    gameId: game.gametype,
    gameName: game.name,
    gamePosition: typeof index === 'number' ? index + 1 : undefined,
    jackpotCurrency: game.jackpot?.currency as GameEntity['jackpotCurrency'],
    jackpotValue: game.jackpot?.value,
    variantId: game.variant,
    vendorName: game.tables?.length > 0 ? game.tables[0].properties?.vendorName : ''
  });
